import React, { useContext, useMemo } from "react";
import { AppContainer } from "./components/AppContainer";
import { GlobalStyle } from "./components/GlobalStyle";
import { FormContext, FormState } from "./context/formContext";
import { QuestionsView } from "./views/QuestionsView";
import { ContactInformationView } from "./views/ContactInformationView";
import { MaintenanceView } from "./views/MaintenanceView";
import { SuccessView } from "./views/SuccessView";

const formStateToComponent = (state: FormState): React.FC => {
  const stateComponentMap = {
    [FormState.Questions]: QuestionsView,
    [FormState.ContactInfo]: ContactInformationView,
    [FormState.Success]: SuccessView,
  };
  return stateComponentMap[state];
};

const App = (): React.ReactElement => {
  // Toggle maintenance mode here
  const maintenanceMode = false;
  const { formState } = useContext(FormContext);
  const FormComponent = useMemo(
    () => formStateToComponent(formState),
    [formState]
  );

  const Content = maintenanceMode ? MaintenanceView : FormComponent;

  return (
    <>
      <GlobalStyle />
      <AppContainer>
        <Content />
      </AppContainer>
    </>
  );
};

export default App;
